module.exports = __webpack_public_path__ + "img/triple_golden.e11b6c62.svg";